import { useState, useEffect } from "react";
import axios from "axios";


import AceitacaoCDC from './components/Grid-boletin-solinftech.js';


import GlobalStyle from "../../styles/global-new.js";
import "react-toastify/dist/ReactToastify.css";
import styled from "styled-components";



const Geral = styled.div`
  display: flex;
  justify-content: center;

  width: 100%;
  padding: 20px;

  div {
    transition: transform 0.1s;
  }


    &.zoom-110 {
    font-size: 0.95rem;
    table {
      transform: scale(0.95);
      transform-origin: center;
    }
  }

  &.zoom-125 {
    font-size: 0.90rem;
    table {
      transform: scale(0.89);
      transform-origin: center;
    }
  }

  &.zoom-150 {
    font-size: 0.90rem;
    table {
      transform: scale(0.89);
      transform-origin: center;
    }
  }

  &.zoom-175 {
    font-size: 0.8rem;
    table {
      transform: scale(0.8);
      transform-origin: center;
    }
  }
  @media (max-width:768px) {
    padding: 20px 10px;
    overflow-y: auto;
    width: 100vw;
    height: 100vh;

  }
  

`;


const Div = styled.div`
  width: 100%;


  @media (max-width:768px) {
    width: 90%;

  }
`;










function App() {

  //----------------------------//
  //Ip's da api e do front

  const urlApi = process.env.REACT_APP_API_URL;
  const urlFront = process.env.REACT_APP_FRONT_URL;

  const token = localStorage.getItem('token');


  //Verifica o token do usuário
  const [tToken, setToken] = useState("");
  const getToken = async () => {
    try {
      const res = await axios.get(`${urlApi}logon/token`, { headers: { Authorization: `Bearer ${token}` } });
      setToken(res.data);
    } catch (error) {
      if (error.response && (error.response.status === 400 || error.response.status === 403 || error.response.status === 401)) {
        window.location.href = `${urlFront}login`;
      } else {
        console.error("Erro ao obter token:", error);
      }
    }
  };

  useEffect(() => {

    getToken();

  }, [])


  const [zoomClass, setZoomClass] = useState("");

  useEffect(() => {
    const detectZoom = () => {
      const zoom = window.devicePixelRatio;

      if (zoom >= 1.7) {
        setZoomClass("zoom-175");
      } else if (zoom >= 1.5) {
        setZoomClass("zoom-150");
      } else if (zoom >= 1.25) {
        setZoomClass("zoom-125");
      } else if (zoom >= 1.1) {
        setZoomClass("zoom-110");
      } else {
        setZoomClass(""); // padrão
      }
    };

    window.addEventListener("resize", detectZoom);
    detectZoom();

    return () => window.removeEventListener("resize", detectZoom);
  }, []);





  return (
    <div style={{ maxHeight: '100vh', overflowY: 'auto', overflowX: 'hidden', width: '100vw', }}>
      <Geral >


        <Div>
          <AceitacaoCDC urlApi={urlApi} />

        </Div>



        <GlobalStyle />
      </Geral>
    </div>
  );
}

export default App;
